import {
  getToken,
  getPassword,
  HEADER_METHOD,
  HEADER_BASIC_ENCODED
} from "../../common/constants/authUtil";
import moment from 'moment';
import { Base64 } from 'js-base64';
import * as CONSTANTS from "../../common/constants/constants";
import * as MSG_CONSTANT from "../../common/constants/messages";
import { BaseUrl } from "../../common/constants/envConfig";
const BASE_URL = BaseUrl();

// Funtion to create the patient on submit click
export const createNewPatient = (patientData, initializePatient, enqueueSnackbar, closeSnackbar) => (dispatch) => {
  const basicToken = Base64.encode(`${getToken()}:${Base64.decode(getPassword())}`)
  let details = {
    mrn: patientData.mrn,
    dob: moment(patientData.dob).format(CONSTANTS.DATE_FORMAT.ISO_8601_FORMATS.DATE),
    email: patientData.email,
    firstname: patientData.firstName,
    lastname: patientData.lastName,
    sex: patientData.sex,
  };
  var formBody = [];
  for (var property in details) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(details[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");
  let header = Object.assign({}, HEADER_BASIC_ENCODED);
  header.Authorization = `${header.Authorization} ${basicToken}`;

  //API Call to create the patient
  fetch(BASE_URL + `${CONSTANTS.URLS.CREATE_PATIENT}`, {
    method: HEADER_METHOD.POST,
    body: formBody,
    headers: header,
  })
    .then((response) => {
      return response.json();
    })
    .then((res) => {
      if (res.id) {
        let details = {
          email: patientData.email,
          password: patientData.password,
          countryCode: patientData.countryCode,
          patientId: res.id,
        };
        var formBody = [];
        for (var property in details) {
          var encodedKey = encodeURIComponent(property);
          var encodedValue = encodeURIComponent(details[property]);
          formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");
        let header = Object.assign({}, HEADER_BASIC_ENCODED);
        header.Authorization = `${header.Authorization} ${basicToken}`;

        //API Call to create the mobile user
        fetch(BASE_URL + `${CONSTANTS.URLS.CREATE_USER}`, {
          method: HEADER_METHOD.POST,
          body: formBody,
          headers: header,
        })
          .then((response) => {
            return response.json();
          })
          .then((res) => {
            if (res.requestId) {
              closeSnackbar();
              initializePatient();
              enqueueSnackbar(MSG_CONSTANT.MESSAGES.PATIENT_CREATED, { variant: MSG_CONSTANT.MESSAGES.TYPE.success });
            } else {
              closeSnackbar();
              enqueueSnackbar(res.errors[0].detail, { variant: MSG_CONSTANT.MESSAGES.TYPE.error });
            }
          })
      } else {
        closeSnackbar();
        enqueueSnackbar(res.errors[0].detail, { variant: MSG_CONSTANT.MESSAGES.TYPE.error });
      }
    })
};